import './ApplianceAccordion.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

export default function ApplianceAccordion(props: {
    title: string;
    children?: any;
    open: boolean;
    onClick?: () => void;
}) {
    const { open = false } = props;
    return (
        <div className='appliance-accordion'>
            <div
                className='accordion-header'
                onClick={() => props.onClick && props.onClick()}
            >
                <h2
                    className='title'
                    style={{ color: open ? '#d65e2a' : 'black' }}
                >
                    {props.title}
                </h2>
                <span
                    style={{
                        transform: props.open ? 'rotate(180deg)' : 'none',
                        color: props.open ? '#d65e2a' : 'black',
                    }}
                    className='appliance-accordion-icon'
                >
                    {open ? (
                        <FontAwesomeIcon icon={faMinus} />
                    ) : (
                        <FontAwesomeIcon icon={faPlus} />
                    )}
                </span>
            </div>
            <div
                style={{ display: props.open ? 'block' : 'none' }}
                className='appliance-content'
            >                
                {props.children}
            </div>
        </div>
    );
}
